module.exports = __webpack_public_path__ + "static/media/stop-icon-begin.c55ca817.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/stop-icon-begin.svg
// module id = 645
// module chunks = 0